import { ICompanySettings } from '../../../shared/interfaces/settings/ISettings';
import { formDataHeaders, requests } from '../../../utils/api/api.service';
import { COMPANY_SETTINGS_URL } from '../../../utils/api/endpoints';

export const SettingsService = {
  getAll: (): Promise<ICompanySettings> => requests.get(COMPANY_SETTINGS_URL),
  update: (payload: FormData) =>
    requests.put(COMPANY_SETTINGS_URL, payload, formDataHeaders),
};
